import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IAppDB } from '@/shared/lib/db';
import type { CartItem } from '@/shared/lib/db/schemas/cart.schema';
import { UIError } from '@/shared/utils/ui-error';

export type UseCaseInput = {
  id: string;
};
export type UseCaseOutput = CartItem;

export class GetItemUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private db: IAppDB;

  constructor(db: IAppDB) {
    this.db = db;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { id } = input;

    const item = await this.db.items.get(id);

    if (!item) throw new UIError('ITEM_NOT_FOUND', 'Item não encontrado.');

    return item;
  }
}
